import type { DocMigration } from "../docMigration";
import { forEachRoom } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_30: DocMigration = {
  maxSchemaVersion: "0.0.30",
  apply(json: any) {
    forEachRoom(json, (room) => {
      if (room.layout && room.layout.casework) {
        for (const cw of room.layout.casework) {
          if (cw.dashed === true) {
            cw.lineStyle = "DASHED";
            delete cw.dashed;
          } else if (cw.poche === true) {
            cw.lineStyle = "POCHE";
            delete cw.poche;
          }
        }
      }
    });
    return json;
  },
};

export default migration_0_0_30;
